<twc-paginator *ngIf="current > 0" [length]="total" [current]="current" [pageSize]="pageSize"
    (currentChange)="onCurrentPageChanged($event)">
</twc-paginator>